import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbProgressbarConfig } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { CampaignStatusEnum } from "src/app/shared/enum/campaign-status";
import { ObjectiveTypeEnum } from "src/app/shared/enum/objectives";
import { SelectedLps } from "src/app/shared/models/location-partners/selectedLps";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import {
  advertisingCompaignResult,
  deleteAdCampaign,
  invokeAddAdvertisingCampaign,
  invokeAdvertisingCompaignFilter,
  SetAddAdvertisingCampaign,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeUploadFileWithProgress,
  setFileName,
} from "src/app/store/file/file.actions";
import { uploadFileProgressSelector } from "src/app/store/file/file.selectors";
import {
  locationPartnersComapyNamesSelector,
  saveSelectedLPsSelector,
} from "src/app/store/locationPartner/location-partner.selectors";
import {
  ActionInterface,
  ActionReturned,
  createLocationPartnerAdvertisingCampaign,
  locationCampaignActionsForAdmin,
  locationCampaignActionsForFranchise,
  locationCampaignActionsForLP,
  OptionActionEnum,
} from "src/app/shared/data/actions-data";
import { VideoAdComponent } from "src/app/shared/components/video-ad/video-ad.component";
import { environment } from "src/environments/environment";
import {
  NgbdSortableHeader,
  SortEvent,
} from "src/app/shared/directive/sortable.directive";
import { FilterListAdvertisingCompaign } from "src/app/shared/models/advertising-campaigns/filter-list-advertising-compaign.interface";
import { ResultFilterAdvertisingCompaign } from "src/app/shared/models/advertising-campaigns/result-filter-advertising-compaign.interface";
import { initialState } from "src/app/store/advertisingCampaign/advertisingCampaign.reducers";
import {
  addCampaignSelector,
  deleteAdvertisingCampaignSelector,
  loadingAdvertisingCampaignTableSelector,
  resultFilterAdvertisingCompaignSelector,
} from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import {
  AdvertisingCampaignInterface,
  LocationWithAvailabilities,
} from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import { DeleteComponent } from "src/app/shared/components/drop-zone-options/modal/delete/delete.component";
import { UpdateCampaignStatusComponent } from "../../ads-compaigns/update-campaign-status/update-campaign-status.component";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { UpdateCampaignLPComponent } from "./update-campaign-lp/update-campaign-lp.component";
import { LocationSearchMethod } from "src/app/shared/enum/locationSearchMethod";
import { Router } from "@angular/router";
import { DetailsAdComponent } from "src/app/shared/components/details-modal/details-ad/details-ad.component";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import {
  catchForbiddenError,
  catchServerError,
} from "src/app/store/user/user.actions";
import {
  catchForbiddenErrorSelector,
  catchServerErrorSelector,
} from "src/app/store/user/user.selectors";
import { JwtService } from "src/app/shared/services/jwt.service";
import { Authorities } from "src/app/shared/enum/authorities";
import { FiltersService } from "src/app/shared/services/filters.service";
import { FilterParams } from "src/app/shared/models/filterParams";
import { Constants } from "src/app/shared/data/constants";

import { ApprobationProgressComponent } from "src/app/shared/components/approbation-progress/approbation-progress.component";
import { LPInfo } from "src/app/shared/models/location-partners/lpInfo";
import { SubRoleEnum } from "src/app/shared/models/user/sub_role.interface";
import { ExportData } from "src/app/shared/data/exportData";
import * as saveAs from "file-saver";
import { SubRoleInterface } from "src/app/shared/models/sub-role/subRole.interface";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { saveUpdateFields } from "../../../../store/settings/settings.actions";
@Component({
  selector: "app-campagnes-lp",
  templateUrl: "./campagnes-lp.component.html",
  styleUrls: ["./campagnes-lp-component.scss"],
})
export class CampagnesLPComponent extends BaseComponent implements OnInit {
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  pageSize: number = 10;
  pageNumber: number = 1;
  formFilter: FormGroup;
  submitted: boolean;
  form: FormGroup;
  validate: boolean;
  showAlert: boolean = false;
  showProgress: boolean = false;
  uploadProgress: number = 0;
  files: File[] = [];
  showError: boolean = false;
  isShown: boolean = false;
  filename: string | null = null;
  approveInProgress: boolean;
  uploadFile$: Observable<HttpEvent<any> | null | HttpResponse<any>>;
  uploadFileProgress$: Observable<HttpEvent<any> | null | HttpResponse<any>>;
  selectedLps: string[] = [];
  showSelectedLPs$: Observable<SelectedLps | null>;

  loading$: Observable<boolean | null>;

  options: ActionInterface[] = locationCampaignActionsForAdmin;
  advertisingCampaignFilter: FilterListAdvertisingCompaign = {
    ...initialState.filter,
    pager: {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    },
  };
  resultFilterAdvertisingCampaigns$: Observable<ResultFilterAdvertisingCompaign | null>;
  resultAdvertisingCampaigns: AdvertisingCampaignInterface[] | null;
  count: number;
  successMessage$: Observable<SuccessDto | null>;
  success: string;
  loadingCreate: boolean = false;
  created$: Observable<SuccessDto | null>;
  isLPUser: boolean = true;
  isFranchiseUser: boolean = false;
  isFranchised: boolean = false;

  columns: IColumn[] = [
    {
      key: "title",
      label: "admin.locations.campaigns.campaignName",
      sorter: true,
    },
    {
      key: "companyName",
      label: "admin.locations.campaigns.companyName",
      sorter: true,
    },
    {
      key: "objective",
      label: "admin.locations.campaigns.objective",
      sorter: true,
    },
    {
      key: "updateDate",
      label: "admin.locations.campaigns.updateDate",
      sorter: true,
    },
  ];
  emails: string[] = [];
  catchServerError$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;
  locationWithAvailabilities: LocationWithAvailabilities;
  profileLocationPartner$: Observable<LPInfo | null>;

  filters: FilterParams | null;

  createAdvertisingCampaign: ActionInterface[] =
    createLocationPartnerAdvertisingCampaign;

  roleEnum : RoleEnum
  constructor(
    private store: Store<AppStateInterface>,
    public badgeService: BadgeService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    configPB: NgbProgressbarConfig,
    private translate: TranslateService,
    private router: Router,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private filtersService: FiltersService
  ) {
    super(store);
    configPB.max = 100;
    configPB.striped = true;
    configPB.animated = true;
    configPB.type = "primary";
    configPB.height = "20px";
    this.uploadFileProgress$ = this.store
      .pipe(select(uploadFileProgressSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.uploadFile$ = this.store
      .pipe(select(uploadFileProgressSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.showSelectedLPs$ = this.store
      .pipe(select(saveSelectedLPsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.resultFilterAdvertisingCampaigns$ = this.store
      .pipe(select(resultFilterAdvertisingCompaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loading$ = this.store
      .pipe(select(loadingAdvertisingCampaignTableSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.successMessage$ = this.store
      .pipe(select(deleteAdvertisingCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.created$ = this.store
      .pipe(select(addCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.formFilter = this.fb.group({
      title: [""],
    });
    this.form = this.fb.group({
      lp: [null, [Validators.required]],
    });
    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.forbidden = !authorities.includes(Authorities.ADC_GETALL.toString());
    }

    this.roleEnum = jwtService.getRoleName(jwtService.getToken())
    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["title"],
      this.formFilter
    );

    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      title: this.formFilter.get("title")?.value,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
  }
  ngOnInit(): void {
    const userRole = this.jwtService.getRoleName(localStorage.getItem("token"));
    const userSubRole = this.jwtService.getSubRoleName(
      localStorage.getItem("token")
    );
    this.isLPUser = userRole === RoleEnum.ROLE_LOCATION;
    this.isFranchiseUser = userRole === RoleEnum.ROLE_FRANCHISE;
    this.isFranchised = userSubRole === SubRoleEnum.FRANCHISED;

    if (this.isLPUser) {
      this.columns = this.columns.filter(
        ({ key }) => key !== "companyName" && key !== "objective"
      );
      this.options = locationCampaignActionsForLP;
    }
    if (this.isFranchiseUser) {
      this.options = locationCampaignActionsForFranchise;
    }

    if (this.isFranchised) {
      this.options = [
        ...this.options,
        {
          name: "campaignDetails.viewApprobation",
          icon: "icofont icofont-check-circled",
          type: OptionActionEnum.ADMIN_VIEW_APPROBATION,
          disabled: false,
        },
      ];
    }

    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.loadingCreate = false;
        this.modalService.dismissAll();
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.catchServerError$.subscribe((result) => {
      if (result) {
        this.loadingCreate = false;
        this.store.dispatch(catchServerError({ serverError: null }));
      }
    });
    this.loading$.subscribe((data) => {});
    this.store.dispatch(
      advertisingCompaignResult({ listAdvertisingCompaign: null })
    );
    this.resultFilterAdvertisingCampaigns$.subscribe((result) => {
      if (result) {
        this.resultAdvertisingCampaigns = result.advertisingCampaigns;
        this.count = result.count;
      } else {
        this.invokeTable();
      }
    });
    this.successMessage$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.success = result.message;
        this.store.dispatch(deleteAdCampaign({ successMessage: null }));
        if (this.success != "") {
          this.toastr.success(
            this.translate.instant("response.success." + this.success),
            this.translate.instant("response.successTitle")
          );
          this.invokeTable();
        }
        this.modalService.dismissAll();
        this.clear();
        this.uploadProgress = 0;
        this.showProgress = false;
      }
    });
    this.created$.subscribe((created: SuccessDto | null) => {
      if (created != null) {
        this.loadingCreate = false;
        this.toastr.success(
          this.translate.instant("response.success." + created.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(SetAddAdvertisingCampaign({ adCreated: null }));
        this.clear();
        this.modalService.dismissAll();
        this.submitted = false;
        this.invokeTable();
      }
    });
    this.uploadFile$.subscribe(
      (result: HttpEvent<any> | null | HttpResponse<{ filename: string }>) => {
        if (result?.type == HttpEventType.UploadProgress) {
          this.showProgress = true;
          const total = result?.total ?? 1;
          this.uploadProgress = Math.round((result.loaded / total) * 100);
        }
        if (result?.type == HttpEventType.Response) {
          this.filename =
            (result as HttpResponse<{ filename: string }>)?.body?.filename ??
            "";
          this.submitted = true;
          this.store.dispatch(setFileName({ filename: null }));
          this.store.dispatch(setFileName({ filename: null }));
          setTimeout(() => {
            this.showProgress = false;
          }, 2000);
        }
      }
    );

    this.formFilter.valueChanges.subscribe((value) => {
      this.pageNumber = 1;
      this.pageSize = Constants.defaultTableSize;
      this.advertisingCampaignFilter = {
        ...this.advertisingCampaignFilter,
        title: value.title,
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
      };
      this.invokeTable();
    });
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.LIST_CAMPAIGNS
    );
  }
  changePage(event: number) {
    this.pageNumber = event;
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      pager: {
        ...this.advertisingCampaignFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.invokeTable();
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: pageSize,
      },
    };
    this.invokeTable();
  }

  addCampaign() {
    this.store.dispatch(
      saveUpdateFields({ options: this.createAdvertisingCampaign })
    );
    const modalRef = this.modalService.open(UpdateComponent, {
      centered: true,
    });
    modalRef.componentInstance.type =
      TypeCards.ADMIN_ADVERTISING_CAMPAIGN_CREATE;
    modalRef.componentInstance.isCol4 = false;
    modalRef.componentInstance.title = "advertisingCampaign.create.title";
    modalRef.componentInstance.isConfirmButton = false;
  }
  onSubmitCreateCampaign() {
    this.locationWithAvailabilities = {
      companyName: this.form.get("lp")?.value,
      listOfAvailableDates: [],
    };
    this.submitted = true;
    this.loadingCreate = true;
    this.validate = this.form.invalid;
    if (!this.validate) {
      this.store.dispatch(
        invokeAddAdvertisingCampaign({
          addCampaign: {
            startingDate: null,
            title: this.formFilter.get("title")?.value,
            endingDate: null,
            objectiveName: ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH,
            redirectionLink: "",
            locationPartners: [this.locationWithAvailabilities],
            videoLink: this.filename,
            status: CampaignStatusEnum.WAITING,
            estimateId: null,
            calculationMethod: LocationSearchMethod.LOCATION_PARTNER,
            totalHt: null,
            formId: null,
            advertiserEmail: null,
          },
        })
      );
    }
  }
  onSelect(event: File[]) {
    if (event[0].size > 5242880) {
      this.showError = true;
      this.showProgress = false;
    } else {
      this.files.push(event[0]);
      this.isShown = true;
      const formData = new FormData();
      formData.append("file", this.files[0], this.files[0].name);
      this.store.dispatch(invokeUploadFileWithProgress({ file: formData }));
    }
  }
  onRemove() {
    this.filename = null;
    this.files = [];
    this.uploadProgress = 0;
    this.showProgress = false;
  }
  clear() {
    this.onRemove();
    this.form.reset({
      title: "",
    });
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (column != header.sortable) {
        header.direction = "";
      }
    });
    var col: string | null = column;
    var sort = null;
    switch (direction) {
      case "asc":
        sort = true;
        break;
      case "desc":
        sort = false;
        break;
      default:
        sort = true;
        col = null;
    }

    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      sortName: column,
      isAscending: sort,
    };
    this.invokeTable();
  }

  saveOption(action: ActionReturned, ad: AdvertisingCampaignInterface) {
    switch (action.option.type) {
      case OptionActionEnum.CAMPAIGNS_STATISTICS: {
        this.router.navigate(
          this.isLPUser
            ? [
                '/',
                'dashboard',
                'location-partner',
                'LPCampaigns',
                'statistics',
                ad.advertisingCampaignHashedId
              ]
            : this.isFranchiseUser
            ? [
                '/',
                'dashboard',
                'franchise',
                'location-partners',
                'campagnes',
                'statistics',
                ad.advertisingCampaignHashedId
              ]
            : [
                '/',
                'dashboard',
                'admin',
                'location-partners',
                'campagnes',
                'statistics',
                ad.advertisingCampaignHashedId
              ]
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.CAMPAIGN_LOCATIONS_STATISTICS
        );
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_SHOW_VIDEO: {
        const modal = this.modalService.open(VideoAdComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.videoLink =
          environment.CDN_RELEAD + ad.videoLink;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.CAMPAIGN_LOCATIONS_SHOW_VIDEO
        );
        break;
      }
      case OptionActionEnum.CAMPAIGN_DELETE: {
        const modal = this.modalService.open(DeleteComponent, {
          centered: true,
        });
        modal.componentInstance.name = "pop-up.campaign.title";
        modal.componentInstance.reference = ad.title;
        modal.componentInstance.CampaignHashedId =
          ad.advertisingCampaignHashedId;
        modal.componentInstance.title = action.option.name;
        modal.componentInstance.type = OptionActionEnum.CAMPAIGN_DELETE;
        modal.componentInstance.publisherRole = RoleEnum.ROLE_LOCATION;
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS: {
        const modal = this.modalService.open(UpdateCampaignStatusComponent, {
          centered: true,
        });
        modal.componentInstance.detailsAd = ad;
        modal.componentInstance.publisherRole = ad.publisherRole;
        modal.componentInstance.isFranchise = this.isFranchiseUser;
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_LP_UPDATE: {
        const modal = this.modalService.open(UpdateCampaignLPComponent, {
          centered: true,
        });
        modal.componentInstance.ad = ad;
        break;
      }
      case OptionActionEnum.CAMPAIGN_DETAILS: {
        const modal = this.modalService.open(DetailsAdComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.detailsAd = ad;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.CAMPAIGN_LOCATION_DETAILS
        );
        break;
      }
      case OptionActionEnum.ADMIN_VIEW_APPROBATION: {
        const modal = this.modalService.open(ApprobationProgressComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.campaignStatus = ad.status;
        modal.componentInstance.campaignName = ad.title;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
    }
  }

  invokeTable() {
    this.store.dispatch(invokeApiDistroyed());
    this.store.dispatch(
      invokeAdvertisingCompaignFilter({
        filter: {
          ...this.advertisingCampaignFilter,
          roleNames: [RoleEnum.ROLE_LOCATION, RoleEnum.ROLE_FRANCHISE],
        },
        refreshCache: false,
      })
    );
  }

  getOptions(ad: AdvertisingCampaignInterface) {
    if (
      ad.status === CampaignStatusEnum.CANCELED_BY_FRANCHISE ||
      ad.status === CampaignStatusEnum.CANCELED ||
      ad.status === CampaignStatusEnum.FINISHED
    ) {
      return this.options.filter(
        (option) =>
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_LP_UPDATE &&
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS
      );
    }

    if(this.roleEnum === RoleEnum.ROLE_FRANCHISE && ad.status === CampaignStatusEnum.WAITING){
      return this.options.filter(
        (option) =>
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_LP_UPDATE &&
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS
      );
    }
    return this.options;
  }

  convertToCsv() {
    const csvRows: string[] = [];
    const headers = [
      ...this.columns,
      { label: "admin.locations.campaigns.status" },
    ].map((item) => this.translate.instant(item.label));
    this.resultAdvertisingCampaigns?.forEach((adCampaign) => {
      const row = [
        adCampaign.title,
        adCampaign.publisherCompanyName,
        adCampaign.objectiveName,
        adCampaign.publishDate,
        adCampaign.status,
      ];
      csvRows.push(row.join(","));
    });
    this.modalService.dismissAll();
    return [headers, ...csvRows].join("\n");
  }

  exportToCsv() {
    const csvData = this.convertToCsv();
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    saveAs(
      blob,
      `${this.translate.instant("admin.locations.campaigns.title")}.csv`
    );

    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.EXPORT_ADVERTISING_CAMPAIGN
    );
  }
}
